import { render, staticRenderFns } from "./SswgWarningTips.vue?vue&type=template&id=53e66544&scoped=true"
import script from "./SswgWarningTips.vue?vue&type=script&lang=js"
export * from "./SswgWarningTips.vue?vue&type=script&lang=js"
import style0 from "./SswgWarningTips.vue?vue&type=style&index=0&id=53e66544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e66544",
  null
  
)

export default component.exports